import { SetHeaderPreviewType } from "./types";

export const setHeaderPreviewSlr = (state: any): SetHeaderPreviewType => state.header.setHeaderPreview;
